import { Article } from '@wix/answers-api';
import { CustomModalLayout, Modal } from '@wix/design-system';
import React, { FC, useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

import { SiteList, SiteListProps } from './SiteList';

import s from './index.module.scss';

export type SiteSelectorModalProps = Omit<
  SiteListProps,
  'isModalOpen' | 'modalSessionId'
> & {
  article: Article;
  isOpen: boolean;
  onClose: () => void;
};

export const SiteSelectorModal: FC<SiteSelectorModalProps> = ({
  article,
  isOpen,
  onClose,
  ...listProps
}) => {
  const [modalSessionId, setModalSessionId] = useState<string>('');

  useEffect(() => {
    if (isOpen) {
      setModalSessionId(uuid());
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      zIndex={1000000}
    >
      <div className={s.siteSelectorModal}>
        <CustomModalLayout
          className={s.modalLayout}
          closeButtonProps={{ onClick: onClose, size: 'medium', skin: 'standard' }}
          showHeaderDivider={false}
          showFooterDivider={false}
          removeContentPadding={true}
          content={
            <SiteList
              {...listProps}
              article={article}
              isModalOpen={isOpen}
              modalSessionId={modalSessionId}
              onClose={onClose}
            />
          }
        />
      </div>
    </Modal>
  );
};
